import { render } from "./ComTest.vue?vue&type=template&id=3a4ec9ac"
import script from "./ComTest.vue?vue&type=script&lang=js"
export * from "./ComTest.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Projects\\JCXS\\CAAMSNG\\frontend-caams\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__